<template>
  <main>
    <div style="margin-bottom: 20px" class="mt-5">
      <label class="common-label-title">Important information regarding Student Passes</label>
    </div>
    <p>
      The School is obliged to lodge an e-cancellation for student on a Student Pass with the Immigration Checkpoints Authority (ICA) within 7 days of the date
      that enrollment for a student at the School ceases. The School will take this Withdrawal Notice as an instruction from you to cancel the student’s Student
      Pass where applicable. The reason for withdrawal is mandatory as this information will have to be submitted to ICA. The student should surrender the
      Student Pass identity card either at ICA or at the checkpoint when leaving Singapore. ICA will grant the student a Social Visit Pass which will allow the
      student to remain in Singapore for up to 30 days after the Student Pass is canceled.
    </p>
    <strong v-if="isInternationalSchool">Important information regarding Fee Protection Scheme (FPS)</strong>
    <p v-if="isInternationalSchool">If applicable, the School will terminate the insurance under FPS on the student’s last day of School as stated above.</p>
  </main>
</template>

<script>
export default {
  props: ['group', 'isInternationalSchool'],
  data() {
    return {
      selected: '',
    }
  },
  methods: {
    async changeStudPassHolder(event) {
      this.selected = event.target.value
      this.$emit('change', this.selected)
    },
  },
}
</script>
